module.exports = __webpack_public_path__ + "assets/sounds/keyboard.mp3";